module.exports = __webpack_public_path__ + "img/wx.10bb41c5.png";